import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import ProgramareNoua from "@/views/ProgramareNoua.vue";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }

      if (to.hash) {
        return new Promise(resolve => {
          setTimeout(() => {
            const element = document.querySelector(to.hash)

            if (element) {
              const top = element.getBoundingClientRect().top + window.pageYOffset - 80

              resolve({
                x: 0,
                y: top
              })
            } else {
              resolve({ x: 0, y: 0 })
            }
          }, 300)
        })
      }

      return { x: 0, y: 0 }
    },
  routes: [
    {
      path: '/',
      redirect: 'comenzi'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('../views/ForgotPassword.vue')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('../views/ResetPassword.vue')
    },
    {
      path: '/intrare-noua/:id',
      name: 'intrare-noua-by-id',
      component: () => import('../views/IntrareNoua.vue')
    },
    {
      path: '/intrare-noua',
      name: 'intrare-noua',
      component: () => import('../views/IntrareNoua.vue')
    },
    // Rutele vechi `-v2` redirecționează spre cele canonice (păstrate pentru
    // link-urile de test; intrarea nouă e acum IntrareNouaV2 pe /intrare-noua).
    {
      path: '/intrare-noua-v2/:id',
      redirect: to => ({ name: 'intrare-noua-by-id', params: to.params })
    },
    {
      path: '/intrare-noua-v2',
      redirect: { name: 'intrare-noua' }
    },
    {
      path: '/devize',
      name: 'devize',
      component: () => import('../views/Devize.vue')
    },
    {
      path: '/programare-noua',
      name: 'programare-noua',
      component: ProgramareNoua
    },
    {
      path: '/comenzi',
      name: 'comenzi',
      component: () => import('../views/Comenzi.vue')
    },
    {
      path: '/comanda/:id',
      name: 'comanda',
      component: () => import('../views/Comanda-1.vue')
    },
    {
      path: '/deviz/:id',
      name: 'deviz',
      component: () => import('../views/Deviz.vue')
    },
    {
      path: '/deviz-simplu/:id',
      name: 'deviz-simplu',
      component: () => import('../views/DevizSimplu.vue')
    },
    {
      path: '/deviz-invoice/:id',
      name: 'deviz-invoice',
      component: () => import('../views/Deviz_Invoice.vue')
    },
    {
      path: '/deviz-auto/:id',
      name: 'deviz-auto',
      component: () => import('../views/Deviz_Auto.vue')
    },
    {
      path: '/deviz-model-3/:id',
      name: 'deviz-model-3',
      component: () => import('../views/Deviz_Model_3.vue')
    },
    {
      path: '/deviz-oferta/:id',
      name: 'Deviz-Oferta',
      component: () => import('../views/Deviz_Oferta.vue')
    },
    {
      path: '/clienti',
      name: 'clienti',
      component: () => import('../views/Clienti.vue')
    },
    {
      path: '/facturi',
      name: 'facturi',
      component: () => import('../views/Facturi.vue')
    },
    {
      path: '/programari',
      name: 'programari',
      component: () => import('../views/Programari.vue')
    },
    {
      path: '/links',
      name: 'links',
      component: () => import('../views/Links.vue')
    },
    {
      path: '/setari',
      name: 'setari',
      component: () => import('../views/Settings.vue'),
      children: [
        {
          path: 'date-service',
          name: 'setari-date-service',
          component: () => import('../views/SettingsDateService.vue')
        },
        {
          path: 'logo',
          name: 'setari-logo',
          component: () => import('../views/Settings_Logo.vue')
        },
        {
          path: 'tarife',
          name: 'setari-tarife',
          component: () => import('../views/SettingsTarife.vue')
        },
        {
          path: 'modele-devize',
          name: 'setari-modele-devize',
          component: () => import('../views/SettingsModeleDevize.vue')
        },
        {
          path: 'general',
          name: 'setari-general',
          component: () => import('../views/SettingsGeneral.vue')
        },
        {
          path: 'mecanici',
          name: 'setari-mecanici',
          component: () => import('../views/SettingsMecanici.vue')
        },
        {
          path: 'rapoarte',
          name: 'setari-rapoarte',
          component: () => import('../views/SettingsRapoarte.vue')
        },
        {
          path: 'integrari',
          name: 'setari-integrari',
          component: () => import('../views/SettingsIntegrari.vue')
        },
        {
          path: 'contact',
          name: 'setari-contact',
          component: () => import('../views/SettingsContact.vue')
        },
        {
          path: 'securitate',
          name: 'setari-securitate',
          component: () => import('../views/SettingsSecuritate.vue')
        }
      ]
    }
  ]
})

const _push = router.push.bind(router)
const _replace = router.replace.bind(router)
// Covers all 4 vue-router navigation-interruption types (duplicated/aborted/
// redirected/cancelled) — matching only name/message missed NavigationCancelled,
// which has neither a `.name` nor a "navigation guard" substring in its message.
export function _Is_Nav_Error (err) {
  return !!(err && err._isRouter)
}
router.push = function (location) { return _push(location).catch(err => { if (!_Is_Nav_Error(err)) throw err }) }
router.replace = function (location) { return _replace(location).catch(err => { if (!_Is_Nav_Error(err)) throw err }) }

router.onError((error) => {
  if (
    error.message.includes('Loading chunk') ||
    error.message.includes('Unexpected token')
  ) {
    window.location.reload()
  }
})

const EXPIRED_BLOCKED_ROUTES = ['intrare-noua', 'intrare-noua-by-id']
const PUBLIC_ROUTES = ['login', 'forgot-password', 'reset-password']

router.beforeEach((to, from, next) => {
  if (PUBLIC_ROUTES.indexOf(to.name) !== -1) return next()

  if (!store.state.auth.user.name) {
    return store.dispatch('check_login_by_cookie', next)
  }

  if (EXPIRED_BLOCKED_ROUTES.indexOf(to.name) !== -1 && store.state.setari.settings.expired) {
    store.commit('SET_SUBSCRIPTION_EXPIRED_MODAL', true)
    return next(from)
  }

  next()
})

export default router
